/**
 * Project Name: Brainsie eCommerce v4
 * Hook: useSectionData
 * Description: Custom hook for fetching section components
 * Author: Brainsie Team
 * Date Created: October 24, 2025
 */

import { useState, useEffect } from "react";
import { getSectionComponentsBySectionId } from "services/cmsServices";

export const useSectionData = (sectionId) => {
  const [components, setComponents] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!sectionId) return;

    const fetchComponents = async () => {
      setLoading(true);
      setError(null);

      try {
        // Note: This API endpoint might need to be created if it doesn't exist
        const response = await getSectionComponentsBySectionId(sectionId);
        if (response.status === 200 && response.data) {
          setComponents(response.data);
        } else {
          setComponents([]);
        }
      } catch (err) {
        console.error("Error fetching section components:", err);
        setError(err);
        setComponents([]);
      } finally {
        setLoading(false);
      }
    };

    fetchComponents();
  }, [sectionId]);

  return {
    components,
    loading,
    error,
  };
};
